import { NivelToast } from "./ConstantesToast";

class NotificacionToast {
    constructor(titulo, mensaje, nivel) {
        this.titulo = titulo;
        this.mensaje = mensaje;
        this.nivel = nivel;
    }
}

class NotificacionToastDeError extends NotificacionToast {
    constructor(titulo, labelCodigoError, codigoError, mensaje) {
        super(titulo, mensaje, NivelToast.ERROR);
        this.labelCodigoError = labelCodigoError;
        this.codigoError = codigoError;
    }
}

class NotificacionToastDeCreacion extends NotificacionToast {
    constructor(titulo, mensaje, id) {
        super(titulo, mensaje, NivelToast.EXITO);
        this.id = id;
    }
}

export { NotificacionToast, NotificacionToastDeError, NotificacionToastDeCreacion };
